export enum AccessTokenType {
  Regular = 'Regular',
  OtpRequired = 'OtpRequired',
  ExpiredPassword = 'ExpiredPassword',
  AgreementAcceptanceRequired = 'AgreementAcceptanceRequired',
}

export interface LoginData {
  accessToken: string;
  refreshToken: string;
  otpRequired?: boolean;
  accessTokenType?: AccessTokenType;
}
